import { ITags } from 'features/inventory/documents-G4/types';
import { BaseService } from 'shared/services/BaseService';

class FMTagService extends BaseService<ITags> {
  constructor() {
    super('tags');
  }

  //   const deleteDocument = async (params, documentId) => {
  //     // Add your API call logic here
  //     return axios.delete(`/api/documents/${documentId}`);
  //   };
}

export const fmTagService = new FMTagService();
